




import { Component } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
@Component({})
export default class PdFollow extends AbpBase {
  constructor(){
    super();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdOutPatient/pdFollow/index.vue